import { Outlet, useNavigate, useRouterState } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { bff } from '../lib/bff-client'
import { useAuth } from '../lib/auth-store'
import { ApiError } from '@crm/api-client'

export function RootLayout() {
  const navigate = useNavigate()
  const user = useAuth((s) => s.user)
  const setUser = useAuth((s) => s.setUser)
  const initialized = useAuth((s) => s.initialized)
  const routerState = useRouterState()
  const path = routerState.location.pathname

  // Boot: hydrate /auth/me. Si 401 → clear user. Público: /login.
  const meQ = useQuery({
    queryKey: ['auth-me'],
    queryFn: () => bff.me(),
    enabled: !initialized,
    retry: false,
    staleTime: Infinity,
  })

  useEffect(() => {
    if (meQ.isSuccess && meQ.data) setUser(meQ.data)
    if (meQ.isError) {
      if (meQ.error instanceof ApiError && meQ.error.status === 401) setUser(null)
    }
  }, [meQ.isSuccess, meQ.isError, meQ.data, meQ.error, setUser])

  // Redirect gating — only when auth is initialized
  useEffect(() => {
    if (!initialized) return
    if (!user && path !== '/login') navigate({ to: '/login' })
    if (user && path === '/login') navigate({ to: '/' })
  }, [initialized, user, path, navigate])

  if (!initialized) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-400">
        Cargando sesión…
      </div>
    )
  }

  // Login page sin chrome — layout mínimo
  if (path === '/login') {
    return (
      <div className="min-h-screen bg-background text-foreground">
        <Outlet />
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <header className="border-b bg-white px-6 py-3 flex items-center justify-between">
        <div>
          <h1 className="text-lg font-semibold">Ingenios Apps Platform — Admin</h1>
          <div className="text-xs text-slate-500">
            BFF: {import.meta.env.VITE_API_URL}
          </div>
        </div>
        {user && (
          <div className="flex items-center gap-3 text-sm">
            <span className="text-slate-600">{user.email}</span>
            <button
              onClick={async () => {
                await bff.logout()
                setUser(null)
                navigate({ to: '/login' })
              }}
              className="rounded border px-3 py-1 text-xs hover:bg-slate-100"
            >
              Logout
            </button>
          </div>
        )}
      </header>
      <main className="p-6">
        <Outlet />
      </main>
    </div>
  )
}
